import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { getTranslations } from '../../utils'

import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'

export default function LoginLink(){
    const { haveaccount } = getTranslations()
    return(
        <Grid container justifyContent="flex-end">
            <Grid item>
                <Link 
                    to="/auth/signin"
                    component={RouterLink} 
                    variant="body2"  
                    color="#6415ff"
                >
                    {haveaccount}
                </Link>
            </Grid>
        </Grid>
    )
}